import "./ReviewLibrary.module.css";
import Header from "@/reusable_sections/Header";
import PageIntro from "./sections/PageIntro";
import CreatorReviewsSection from "./sections/CreatorReviewsSection";
import CreatorReviewGrid from "./sections/CreatorReviewGrid";
import FeedbackCallToAction from "./sections/FeedbackCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ReviewLibraryPage() {
  return <div>
      <Header />
      <PageIntro />
      <CreatorReviewsSection />
      <CreatorReviewGrid />
      <FeedbackCallToAction />
      <Footer />
    </div>;
}